$(function () {
  // Initialize Swiper without autoplay initially
  var swiper6 = new Swiper(".cryoTimeline", {
    slidesPerView: 2.75,
    spaceBetween: 0,
    speed: 250,
    autoplay: false, // Initially off
    navigation: {
      nextEl: ".timeline-next",
      prevEl: ".timeline-prev",
    },
    breakpoints: {
      280: {
        slidesPerView: 1,
        spaceBetween: 0,
      },
      720: {
        slidesPerView: 1.67,
        spaceBetween: 0,
      },
      992: {
        slidesPerView: 2.76,
        spaceBetween: 0,
      },
    },
  });


});
